<footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-6 logo-section" [ngClass]="{'text-end': isArabic}">
          <img src="assets/images/logo-removebg-preview.png" alt="Hurghada Radio Logo" class="logo w-25">
          <p class="description">
            @if(isArabic){ راديو الغردقة هو صوت المدينة اللي بيعبر عن كل اللي بيحصل فيها. إحنا منصة صوتية جديدة هدفها إننا ننقل لكل الناس، سواء كانوا من سكان الغردقة أو زوارها، كل اللي يهمهم يعرفوه عن المدينة. من الأخبار المحلية، للمزيكا اللي بتناسب كل الأذواق، ولحد الفعاليات والأنشطة اللي بتحصل يوم بيوم. } @else{ Hurghada Radio is the voice of the city, reflecting everything that happens within it. We are a new audio platform dedicated to delivering essential information to both residents and visitors of Hurghada. From local news, to music that caters to all tastes, and daily updates on events and activities. }
          </p>
        </div>
  
        <div class="col-md-6 links-section" [ngClass]="{'text-start': isArabic}">
          <ul class="footer-links">
            <li><a routerLink="home" routerLinkActive="router-link-active"> @if (isArabic) { الرئيسية } @else { Home } </a></li>
            <li><a routerLink="about" routerLinkActive="router-link-active"> @if (isArabic) { عنا } @else { About Us} </a></li>
            <!-- <li><a routerLink="" routerLinkActive="router-link-active">Show Schedule</a></li>
            <li><a routerLink="" routerLinkActive="router-link-active">Blog</a></li> -->
            <li><a routerLink="contact" routerLinkActive="router-link-active"> @if (isArabic) { تواصل معنا } @else { Contact } </a></li>
            <li><a routerLink="news" routerLinkActive="router-link-active"> @if (isArabic) { أخر الأخبار } @else { News } </a></li>
            <li><a routerLink="chat" routerLinkActive="router-link-active"> @if (isArabic) { دردشة مباشرة } @else { Live Chat } </a></li>
          </ul>
        </div>
      </div>
  
      <div class="row bottom-row">
        <div class="col-md-6 copyright">
          © {{year}}  @if (isArabic) { راديو الغردقة جميع الحقوق محفوظة . } @else { Hurghada Radio All rights reserved .}
        </div>
        <div class="col-md-6 social-icons" [ngClass]="{'text-start': isArabic}">
            @for (item of socials; track $index) {
                <a [href]="item.link" target="_blank"><i [class]="item.icon"></i></a>
            }
        </div>
      </div>

      <div class="text-center mt-4 acme">
        Made With <i class="fa-solid fa-heart text-danger"></i> By <a href="https://acmecode-eg.com/" target="_blank"> AcmeCode </a>
      </div>

    </div>
  </footer>  